// import axios from "axios";

// export default axios.create({
//   baseURL:'https://206.189.112.218/api/'
// });

import axios from "axios";
import { GetLocalStorage } from "./resource";
// import jwtDecode from "jwt-decode";
// import jwtDecode from "jwt-decode";
// import { apiToken } from "./api-helpers";
// import dayjs from "dayjs";
// import redirectUser from "../routes/Redirect";
// import { HOME } from "../routes/Constant";

// console.log(jwtDecode(apiToken?.token))

const data = GetLocalStorage();



const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${data?.auth_token}`,
  },
});

// let apiToken = "";

// export const formApi = axios.create({
//   baseURL: process.env.REACT_APP_BACKEND_URL,
//   headers: {
//     "Content-Type": "multipart/form-data",
//     Authorization: "Bearer " + apiToken?.accessToken,
//   },
// });

// api?.interceptors?.request?.use(async (req) => {
//   if (!apiToken) {
//     apiToken = localStorage.getItem("token")
//       ? JSON.parse(localStorage.getItem("token"))
//       : null;
//     req.headers.Authorization = `Bearer ${apiToken?.accessToken}`;
//   }

//   let user = jwtDecode(apiToken?.accessToken);
//   let isExpired = dayjs.unix(user?.exp).diff(dayjs()) < 1;

//   if (isExpired) {
//     localStorage.removeItem("token");
//     localStorage?.removeItem("permission");
//     alert("Token has expired");
//     // redirectUser(HOME, 1);
//   }

//   return req;
// });

export default api;
